import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

// Helper to format Java timestamp array [year,month,day,hour,min,sec]
const formatTimestampArray = (ts) => {
  if (!ts || !Array.isArray(ts) || ts.length < 6) return 'NA';
  const [year, month, day, hour, min, sec] = ts;
  const d = new Date(year, month - 1, day, hour, min, sec);
  return d.toLocaleString(); // Simplified for stability
};

const COLUMNS = [
  { label: 'Alert ID', key: 'alertSeqId' },
  { label: 'Region', key: 'regionName' },
  { label: 'Hazard Type', key: 'hazardType' },
  { label: 'Severity', key: 'severity' },
  { label: 'Measured Value', key: 'measuredValue' },
  { label: 'Threshold Value', key: 'thresholdValue' },
  { label: 'Unit', key: 'unit' },
  { label: 'Incident Date & Time', key: 'timestamp' },
  { label: 'Status', key: 'acknowledged' },
  { label: 'Latitude', key: 'latitude' },
  { label: 'Longitude', key: 'longitude' },
  { label: 'Description', key: 'alertDescription' },
];

// This MUST be a named export matching your handler's import
export const generatePreDisasterAlertExcel = async ({ data, filename }) => {
  try {
    const transformed = data.map(rec => {
      const out = {};
      COLUMNS.forEach(col => {
        let val = rec[col.key];
        if (col.key === 'timestamp') val = formatTimestampArray(val);
        else if (col.key === 'acknowledged') val = val === true ? 'Acknowledged' : 'Pending';
        out[col.label] = (val !== null && val !== undefined) ? val : 'NA';
      });
      return out;
    });

    const worksheet = XLSX.utils.json_to_sheet(transformed);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Alerts");
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const finalData = new Blob([excelBuffer], { type: 'application/octet-stream' });
    
    saveAs(finalData, `${filename}.xlsx`);
  } catch (error) {
    console.error("❌ Excel Generation Error:", error);
  }
};